import {useQuery} from "../../hooks/useQuery";
import {LoaderBlockUI} from "../../components/loader";
import {useContext, useEffect, useState} from "react";
import {HttpAuth} from "../../http/user/httpAuth";
import {HttpAxiosRequest} from "../../http/httpAxiosBase";
import {userStorage} from "../../utils/localStorage/userStorage";
import {useNavigate} from "react-router-dom";
import {CompanyContext, CompanyContextValue} from "../solicitation-new/context/companyContext";


const LoginByTokenPageLoader = () => {
    const params = useQuery()
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true)
    const {setClientId} = useContext<CompanyContextValue>(CompanyContext)
    
    
    const token = params.get('token')
    const solicitationId = params.get('solicitationId')

    useEffect(() => {
        if (token !== null) {
            HttpAxiosRequest.refreshToken(token)

            HttpAuth.validateToken().then((response) => {
                userStorage.save(
                    response.idUsuario,
                    response.idGrupo,
                    response.idPerfil,
                    response.idRolPersona,
                    response.cantDiasParaCambiarPass,
                    response.apellidoNombre,
                    response.idiomaDefault,
                    response.esGrupoBanco,
                    response.esGrupoInterno,
                    response.tokenAutorizacion
                );
                
                setClientId(0) //ver si esto es necesario
                setLoading(false)
                
                if (solicitationId) {
                    const id = parseInt(solicitationId)
                    navigate(`/solicitudes/${id}`)
                } else {
                    navigate('/solicitudes');
                }

            })
        }
    }, []);
    
    return (
        loading ?
        <LoaderBlockUI message={'Aguarde mientras obtenemos la información del usuario...'}
                       sxProps={{
                           backgroundColor: 'rgb(0,0,0)',
                           border: 'none !important'
                       }}
        />
            :
            <></>
    )
}


export default LoginByTokenPageLoader